// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"2c5d004d","252":"363ebee5","354":"7b52d2fa","664":"8346cdf2","837":"f14b46e1","886":"200f3415"}[chunkId] + ".chunk.js";
};